<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="shipping-detail">
    <!-- 加载状态 -->
    <el-skeleton v-if="loading" :rows="6" animated />
    
    <!-- 详情内容 -->
    <div v-else>
      <!-- 基本信息 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="card-title">基本信息</span>
        </div>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="订单号">{{ shipping_info.order_no }}</el-descriptions-item>
          <el-descriptions-item label="发货状态">
            <el-tag :type="shipping_info.status | statusTypeFilter">
              {{ shipping_info.status | statusFilter }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="支付状态">
            <el-tag :type="shipping_info.pay_status | payStatusTypeFilter">
              {{ shipping_info.pay_status | payStatusFilter }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ shipping_info.create_time }}</el-descriptions-item>
        </el-descriptions>
      </el-card>

      <!-- 供应商信息 -->
      <!-- <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="card-title">供应商信息</span>
        </div>
        <div class="supplier-info">
          <el-image 
            class="supplier-image"
            :src="shipping_info.supplier.image_url.replace(/\\/g, '/')"
            fit="cover"
          ></el-image>
          <div class="supplier-detail">
            <p class="name">{{ shipping_info.supplier.name }}</p>
            <p>地址：{{ shipping_info.supplier.address }}</p>
            <p>联系电话：{{ shipping_info.supplier.uphone || '-' }}</p>
          </div>
        </div>
      </el-card> -->

      <!-- 仓库信息 -->
      <!-- <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="card-title">仓库信息</span>
        </div>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="仓库名称">{{ shipping_info.warehouse.name }}</el-descriptions-item>
          <el-descriptions-item label="仓库编码">{{ shipping_info.warehouse.code }}</el-descriptions-item>
          <el-descriptions-item label="仓库地址">{{ shipping_info.warehouse.address }}</el-descriptions-item>
          <el-descriptions-item label="联系人">{{ shipping_info.warehouse.linkman }}</el-descriptions-item>
        </el-descriptions>
      </el-card> -->

      <!-- 商品列表 -->
      <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span class="card-title">商品清单</span>
    <!-- 拼柜号码输入框 -->
    <el-input
      v-model="containerNumber"
      placeholder="请输入拼柜号码"
      clearable
      class="container-input"
      @blur="handleSaveContainer"
      @keyup.enter="handleSaveContainer"
      v-if="shipping_info.gz_type === 1"
    >
      <template #prepend>
        <i class="el-icon-box"></i>
      </template>
    </el-input>
  </div>
  
  <el-table :data="shipping_info.products" border>
    <!-- 原有列保持不变 -->
    <el-table-column prop="product.product_name" label="商品名称"></el-table-column>
    <!-- <el-table-column label="规格" width="120">
      <template v-slot="{row}">
        {{ row.product_sku_id || '默认规格' }}
      </template>
    </el-table-column> -->
    <el-table-column prop="price" label="单价" width="120">
      <template v-slot="{row}">¥{{ row.price.toFixed(2) }}</template>
    </el-table-column>
    <el-table-column prop="num" label="数量" width="100"></el-table-column>


    <el-table-column label="柜子类型" width="125" >
 
      <template #default="{ row }" >
             <!-- 拼柜出货 -->
        <div v-if="shipping_info.gz_type === 1">
            <div>
              类型：拼柜
            </div>
            <div>
              拼柜立方：{{ row.cube }}
            </div>
        </div>
         <!-- 整柜出货 -->

        <div v-if="shipping_info.gz_type === 2">
          类型：整柜
          </div>
      </template>
     
    </el-table-column>
    <el-table-column label="小计" width="120">
      <template v-slot="{row}">¥{{ (row.price * row.num).toFixed(2) }}</template>
    </el-table-column>

    <el-table-column label="拼柜/海运费/元" width="125" v-if="shipping_info.gz_type === 1">
      <template #default="{ row }">
        <div class="combined-input">
          <el-input
        v-model="row.ccabinet_price"
        placeholder="拼柜费"
        size="mini"
        @blur="savePrice(row, 'ccabinet_price')"
      ></el-input>
          <el-input
            v-model="row.of_price"
            placeholder="海运费"
            size="mini"
            @blur="savePrice(row, 'of_price')"
          ></el-input>
        </div>
      </template>
    </el-table-column>
  
  </el-table>
  <el-button
       type="primary" 
        size="mini"
        class="btn"
        v-if="shipping_info.gz_type === 1 && shipping_info.pay_status != 2"
        @click="handleDelete()"
      >费用通知</el-button>
</el-card>


<el-card  class="box-card">
    <div slot="header" class="clearfix">
      <span class="card-title"><i class="el-icon-user"></i> 发货人信息</span>
    </div>
    
    <el-descriptions :column="2" border>
      <!-- 基本信息 -->
      <el-descriptions-item label="用户ID">{{ senderInfo.user_id }}</el-descriptions-item>
      <el-descriptions-item label="昵称">{{ senderInfo.nickName }}</el-descriptions-item>
      <el-descriptions-item label="手机号">{{ senderInfo.mobile }}</el-descriptions-item>
      <el-descriptions-item label="邮箱">{{ senderInfo.email || '无' }}</el-descriptions-item>
    </el-descriptions>
      
  </el-card>

<el-card class="box-card" v-if="!port && shipping_info.gz_type === 1">
  <div class="port-select-container">
    <!-- 起始港选择 -->
    <div class="port-select-box" @click="openDialog('start')">
      <div class="port-select-label">起始港</div>
      <div class="port-select-content">
        <div v-if="startPort" class="port-info">
          <div class="port-name">{{ startPort.portName }}</div>
          <div class="port-details">
            <span>代码: {{ startPort.portCode }}</span>
            <span>位置: {{ startPort.portLocation }}</span>
          </div>
        </div>
        <div v-else class="port-placeholder">请选择起始港</div>
        <i class="el-icon-arrow-down select-icon"></i>
      </div>
    </div>

    <!-- 目的港选择 -->
    <div class="port-select-box" @click="openDialog('end')">
      <div class="port-select-label">目的港</div>
      <div class="port-select-content">
        <div v-if="endPort" class="port-info">
          <div class="port-name">{{ endPort.portName }}</div>
          <div class="port-details">
            <span>代码: {{ endPort.portCode }}</span>
            <span>位置: {{ endPort.portLocation }}</span>
          </div>
        </div>
        <div v-else class="port-placeholder">请选择目的港</div>
        <i class="el-icon-arrow-down select-icon"></i>
      </div>
    </div>

    <!-- 港口选择对话框 -->
    <el-dialog 
      :title="currentDialogTitle" 
      :visible.sync="showPortDialog" 
      width="60%"
      :before-close="handleDialogClose"
    >
      <div class="port-dialog-content">
        <div class="port-search-box">
          <el-input
            v-model="searchQuery"
            placeholder="输入港口名称搜索"
            clearable
            @clear="handleSearchClear"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </div>
        
        <div class="port-list">
          <div 
            v-for="port in portList" 
            :key="port.gangkou_id"
            class="port-item"
            :class="{ 'selected': isPortSelected(port) }"
            @click="handlePortSelect(port)"
          >
            <div class="port-item-name">{{ port.portName }}</div>
            <div class="port-item-details">
              <span>代码: {{ port.portCode }}</span>
              <span>位置: {{ port.portLocation }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPortDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmPortSelection">确认</el-button>
      </span>
    </el-dialog>
  </div>
</el-card>

<el-card class="box-card" v-if="port">
  <div slot="header" class="clearfix">
    
    <div slot="header" class="clearfix">
        <span class="card-title"><i class="el-icon-ship"></i> 起始港信息</span>
      </div>
      <el-descriptions v-if="startPortInfo && startPortInfo.portName" :column="1" border>
        <el-descriptions-item label="港口名称">{{ startPortInfo.portName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="港口代码">{{ startPortInfo.portCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="港口位置">{{ startPortInfo.portLocation || '-' }}</el-descriptions-item>
        <el-descriptions-item label="港口类型">{{ startPortInfo.portType || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ startPortInfo.linkman || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ startPortInfo.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注信息">{{ startPortInfo.remarks || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div v-else class="empty-tip">
        <el-empty description="暂无起始港信息"></el-empty>
      </div>
      
      <div slot="header" class="clearfix">
        <span class="card-title"><i class="el-icon-location-outline"></i> 目的港信息</span>
      </div>
      <el-descriptions v-if="endPortInfo && endPortInfo.portName" :column="1" border>
        <el-descriptions-item label="港口名称">{{ endPortInfo.portName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="港口代码">{{ endPortInfo.portCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="港口位置">{{ endPortInfo.portLocation || '-' }}</el-descriptions-item>
        <el-descriptions-item label="港口类型">{{ endPortInfo.portType || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ endPortInfo.linkman || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ endPortInfo.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注信息">{{ endPortInfo.remarks || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div v-else class="empty-tip">
        <el-empty description="暂无目的港信息"></el-empty>
      </div>
  </div>

</el-card>

<el-card class="box-card" v-if="shipping_info.pay_status === 2">
  <div slot="header" class="clearfix">
    <div slot="header" class="clearfix">
        <span class="card-title">二维码</span>
    </div>
  </div>
  <div class="barcode-image-container">
    <img 
      :src="shipping_info.er_code" 
      alt="条形码图片"
      v-if="shipping_info.er_code"
      class="barcode-image"
    />
    <div v-else class="no-barcode">
      暂无条形码
    </div>
  </div>
</el-card>

      <!-- 费用信息 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="card-title">费用明细</span>
        </div>
        <div class="price-section">
          <p>商品总价：¥{{ totalPrice.toFixed(2) }}</p>
          <p v-if="shipping_info.ccabinet_price != null && shipping_info.gz_type == 1">拼柜费用：¥{{shipping_info.ccabinet_price.toFixed(2) }}</p>
          <p v-if="shipping_info.ccabinet_price != null && shipping_info.gz_type == 2">整柜费用：¥{{shipping_info.ccabinet_price.toFixed(2) }}</p>
          <p v-if="shipping_info.of_price != null">海运费:¥{{shipping_info.of_price.toFixed(2) }}</p>
          <p class="total-price">客户实付金额：¥{{ actPayPrice.toFixed(2) }}</p>
          <p class="total-price">商家实付金额：¥{{ sjactPayPrice.toFixed(2)}}</p>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  import GangkouApi from '@/api/gangkou.js';
  import OrderApi from '@/api/order.js';
  const config = require('../../../../config'); 
  export default {
    filters: {
    statusFilter(status) {
      const statusMap = { 0: '待发货', 1: '已发货', 2: '已签收' }
      return statusMap[status] || '未知状态'
    },
    statusTypeFilter(status) {
      const typeMap = { 0: 'warning', 1: 'primary', 2: 'success' }
      return typeMap[status] || ''
    },
    payStatusFilter(status) {
      const statusMap = { 0: '未支付', 1: '支付中', 2: '已支付' }
      return statusMap[status] || '未知状态'
    },
    payStatusTypeFilter(status) {
      const typeMap = { 0: 'danger', 1: 'warning', 2: 'success' }
      return typeMap[status] || ''
    }
  },
  props: {
    // 初始选中的港口
    initialStartPort: {
      type: Object,
      default: null
    },
    initialEndPort: {
      type: Object,
      default: null
    },
    senderData: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      loading: true,
      shipping_info: {},
      websocket: null,
      senderInfo:{},
      port:false,
      startPort: this.initialStartPort,
      endPort: this.initialEndPort,
      showStartPortDialog: false,
      showEndPortDialog: false,
      searchQuery: '',
      portList: [], // 所有港口数据
      tempSelectedPort: null, // 临时选中的港口
      currentDialogType: 'start', // 'start' 或 'end'
      startPortInfo: {}, // 起始港详细信息
      endPortInfo: {} ,   // 目的港详细信息
      containerNumber: '',  // 拼柜号码
      saveTimer: null       // 防抖定时器
    }
  },
  // beforeDestroy() {
  //    this.closeWebSocket();
  //   // 移除监听
  //   if (this.websocket) {
  //     this.websocket.close();
  //   }
  // },

  computed: {
    totalPrice() {
    return this.shipping_info.products && 
           this.shipping_info.products.reduce((sum, item) => {
             return sum + (item.price * item.num || 0)
           }, 0) || 0
  },

  showPortDialog: {
      get() {
        return this.showStartPortDialog || this.showEndPortDialog
      },
      set(val) {
        if (!val) {
          this.showStartPortDialog = false
          this.showEndPortDialog = false
        }
      }
    },
    currentDialogTitle() {
      return this.currentDialogType === 'start' ? '选择起始港' : '选择目的港'
    },
    filteredPorts() {
      if (!this.searchQuery) {
        return this.portList
      }
      return this.portList.filter(port => 
        port.portName.includes(this.searchQuery) || 
        port.portCode.includes(this.searchQuery))
    },

  formValid() {
      return this.startPort && this.endPort && this.startPort !== this.endPort
    },

    actPayPrice() {
      return (parseFloat)(this.shipping_info.act_pay_price) || 
        (this.totalPrice + 
        (parseFloat)(this.shipping_info.other_price) - 
        (parseFloat)(this.shipping_info.discount_price)

        )
    },
    sjactPayPrice() {
      console.log('this.shipping_info.of_price',this.shipping_info.of_price)
      console.log('this.shipping_info.ccabinet_price',this.shipping_info.ccabinet_price)
      return (this.shipping_info.of_price)+ (this.shipping_info.ccabinet_price)
   
        
    }
  },

  mounted() {
    this.fetchData()
  },
  created() {
    this.loadPortData()
  },

  methods: {
      // 关闭 WebSocket 连接
    closeWebSocket() {
      if (this.websocket) {
        // 清除重试计数器
        this.websocketRetryCount = 0;
        
        // 只有在连接打开或正在连接时才需要关闭
        if ([WebSocket.OPEN, WebSocket.CONNECTING].includes(this.websocket.readyState)) {
          this.websocket.close();
        }
        this.websocket = null;
      }
    },
     // 加载已有拼柜号码
    //  async loadContainerNumber() {
    //   try {
    //     const res = await api.getContainerNumber(this.orderId)
    //     this.containerNumber = res.data.containerNumber || ''
    //   } catch (error) {
    //     this.$message.error('获取拼柜信息失败')
    //   }
    // },
    
    // 带防抖的保存方法
    handleSaveContainer() {
      clearTimeout(this.saveTimer)
      this.saveTimer = setTimeout(() => {
        this.saveContainerNumber()
      }, 300)
    },

    formatGrade(gradeId) {
      return this.gradeMap[gradeId] || `未知等级(${gradeId})`
    },
    formatRole(role) {
      return this.roleMap[role] || role
    },
    formatRegSource(source) {
      const sources = {
        'h5': 'H5页面',
        'app': '手机应用',
        'pc': '电脑端',
        'wechat': '微信'
      }
      return sources[source] || source
    },
    viewLargeAvatar() {
      if (this.senderInfo.avatarUrl) {
        this.$alert(`<img src="${this.senderInfo.avatarUrl}" style="max-width: 100%;"/>`, '头像大图', {
          dangerouslyUseHTMLString: true,
          customClass: 'avatar-preview-dialog'
        })
      } else {
        this.$message.warning('该用户没有设置头像')
      }
    },

    async loadPortData() {
      try {
        GangkouApi.listx().then(res => {
          this.portList = res.data.list.data
          console.log("portList",this.portList);
          
        })
      } catch (error) {
        console.error('加载港口数据失败:', error)
        this.$message.error('加载港口数据失败')
      }
    },
    //打开对话框时设置当前类型
    openDialog(type) {
      console.log("type",type);
      
      this.currentDialogType = type
      if (type === 'start') {
        this.showStartPortDialog = true
        this.tempSelectedPort = this.startPort
        
        let data = {
          shipping_id: this.$route.query.shipping_id,
          startPort:this.startPort.gangkou_id
    }
       OrderApi.updateShippingInfo(data).then(res => {
        this.$message.success('保存成功');
       })
       
      } else {
        this.showEndPortDialog = true
        this.tempSelectedPort = this.endPort
        let data = {
          shipping_id: this.$route.query.shipping_id,
          endPort:this.endPort.gangkou_id,
    }
      const res =  OrderApi.updateShippingInfo(data) .then(res => {
        this.$message.success('保存成功');
       })
      }
    },
    
    // 检查港口是否被选中
    isPortSelected(port) {
      return this.tempSelectedPort && this.tempSelectedPort.gangkou_id === port.gangkou_id
    },
    
    // 选择港口
    handlePortSelect(port) {
      this.tempSelectedPort = port
    },
    
    // 确认选择
    async confirmPortSelection() {
   
      if (this.currentDialogType === 'start') {
        this.startPort = this.tempSelectedPort
        this.$emit('start-port-change', this.startPort)
      } else {
        this.endPort = this.tempSelectedPort
        this.$emit('end-port-change', this.endPort)
      }

      await this.savePortsToDatabase();
      this.$message.success('港口选择已保存');

      this.showPortDialog = false
    },

    async savePortsToDatabase() {
      
      const portData = {
        shipping_id: this.$route.query.shipping_id,
        startPort: this.startPort ? this.startPort.gangkou_id : null,
        endPort: this.endPort ? this.endPort.gangkou_id : null
      };
      
      const response = await OrderApi.updateShippingInfo(portData);
      return response.data;
    },
    
    // 对话框关闭前处理
    handleDialogClose(done) {
      this.tempSelectedPort = null
      this.searchQuery = ''
      done()
    },
    
    // 搜索港口
    handleSearch() {
      // 搜索逻辑已在 filteredPorts 计算属性中实现
    },
    
    // 清除搜索
    handleSearchClear() {
      this.searchQuery = ''
    },

     // 初始化 WebSocket 连接
     initWebSocket() {
  return new Promise((resolve, reject) => {
    // 如果已有连接且状态为 OPEN/CONNECTING，直接复用
    if (this.websocket && [WebSocket.OPEN, WebSocket.CONNECTING].includes(this.websocket.readyState)) {
      resolve();
      return;
    }

    const wsUrl = config.dev.socket;
    
    this.websocket = new WebSocket(wsUrl);

    this.websocket.onopen = () => {
      console.log('WebSocket 连接已建立');
      resolve(); // 连接成功时解析Promise
    };

    this.websocket.onerror = (error) => {
      console.error('WebSocket 错误:', error);
      reject(error); // 连接失败时拒绝Promise
    };

    this.websocket.onclose = () => {
      console.log('WebSocket 连接已关闭');
    };
  });
},

    async handleDelete() {
      console.log("row",this.shipping_info);
      let totalCcabinet_price = 0
      let totalOf_price = 0
      this.shipping_info.products.forEach(product => {
        totalCcabinet_price += (parseFloat)(product.ccabinet_price);
        totalOf_price += (parseFloat)(product.of_price);

      });

      let total = (parseFloat)(totalCcabinet_price) + (parseFloat)(totalOf_price);
    try {
      let data = {
      shipping_id: this.$route.query.shipping_id,
      pay_status: 1
    }
      const res =  OrderApi.updateShippingInfo(data) ;
      await this.initWebSocket();
    
    if (this.websocket.readyState !== WebSocket.OPEN) {
      this.$message.warning('连接尚未建立，请稍后重试');
      return;
    }
    const mid = 'm' + Math.random().toString(36).substring(2);
    const send_type = 3
    const user = await OrderApi.getuserId({ supply_id: this.shipping_info.supply_id });
    const userid = user.data.detail.user_id;
   
    var message = {
        user_id: 1,
        type: 'chat',
        msgtype: 'system_tip1',
        content: this.$route.query.shipping_id,
        mid: mid,
        to_user_id:userid,
        obj: JSON.stringify({ type: send_type,users:[userid],order_no:this.shipping_info.order_no,total:total})
      };
      this.websocket.send(JSON.stringify(message));
      this.$message.success('系统通知已发送');
      // this.loadData()
    } catch (error) {
      if (error !== 'cancel') {
        this.$message.error(error.message || '失败');
      }
    }
  },
    async savePrice(row, field) {
      console.log(row);
      console.log("field",field);
      try {
        let data = {
          shipping_id: row.shipping_id,
          pay_status: 0,
          [field]: Number(row[field]) 
    }
      const res =  OrderApi.updateShippingProduct(data) ;
        this.$message.success('保存成功');
      } catch (error) {
        this.$message.error('保存失败');
      }
    },
    
    // 实际保存操作
    async saveContainerNumber() {
      if (!this.containerNumber.trim()) {
        this.$message.warning('请输入有效的拼柜号码')
        return
      }
      let shipping_id =  this.$route.query.shipping_id
      try {
        await OrderApi.updateShippingProduct({
          shipping_id: shipping_id,
          gz_code: this.containerNumber
        })
        this.$message.success('拼柜号码保存成功')
      } catch (error) {
        this.$message.error('保存失败，请稍后重试')
        console.error('保存失败:', error)
      }
    },
    async getstartPort(id){
      OrderApi.getPortById({
        "gangkou_id":id
      }).then(res => {
        this.startPortInfo = res.data
        console.log( this.startPortInfo);
        
      })
    },
    async getendPort(id){
      OrderApi.getPortById({
        "gangkou_id":id
      }).then(res => {
        this.endPortInfo = res.data
      })
    },
    async getshipper(id){
      console.log("user_id",id);
      
      OrderApi.getshipper({
        "user_id":id
      }) .then(res => {
        this.senderInfo = res.data
      })
    },
    async fetchData() {
      try {
        // 这里替换为实际的API调用
        const params = this.$route.query.shipping_id;
        OrderApi.shippingdetail({ "shipping_id": params })
        .then(res => {
          console.log("实际响应数据:", res);
          this.shipping_info = res.data.shipping_info;
          this.containerNumber = res.data.gz_code
          console.log("startPort",res.data.shipping_info.startPort);
          if(res.data.shipping_info.startPort !=null && res.data.shipping_info.endPort !=null && res.data.shipping_info.startPort !=""
            &&  res.data.shipping_info.endPort !=""
          ){
            this.port = true
            this.getstartPort(res.data.shipping_info.startPort)
          this.getendPort(res.data.shipping_info.endPort)
          }
          let supplier = res.data.shipping_info.supplier.user_id
          this.getshipper(supplier)
        })
        .catch(error => {
          console.error("请求失败:", error);
        });
        this.loading = false
      } catch (error) {
        this.$message.error('数据加载失败')
        console.error(error)
      }
    }

    
  },
  watch: {
    senderData: {
      immediate: true,
      handler(newVal) {
        this.senderInfo = {
          ...this.senderInfo,
          ...newVal
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box-card {
  margin-bottom: 20px;

  .card-title {
    font-size: 16px;
    font-weight: bold;
  }
}


.port-info-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.port-card {
  flex: 1;
  min-width: 400px;
  margin-bottom: 20px;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
}

.card-title i {
  margin-right: 8px;
  color: #409EFF;
}
.sender-info-card {
  margin: 20px;
  max-width: 1000px;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
}

.card-title i {
  margin-right: 8px;
  color: #409EFF;
}

.avatar-container {
  margin-top: 20px;
  text-align: center;
}

.avatar {
  border: 1px solid #eee;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.avatar-actions {
  margin-top: 10px;
}

/* 大图预览对话框样式 */
>>> .avatar-preview-dialog {
  width: auto;
  max-width: 80%;
}
.empty-tip {
  padding: 20px 0;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .port-card {
    min-width: 100%;
  }
}


.supplier-info {
  display: flex;
  align-items: center;
  
  .supplier-image {
    width: 100px;
    height: 100px;
    margin-right: 20px;
    border-radius: 4px;
  }

  .supplier-detail {
    .name {
      font-size: 16px;
      margin-bottom: 8px;
      font-weight: bold;
    }
  }
}

.price-section {
  text-align: right;
  font-size: 14px;
  
  p {
    margin: 8px 0;
  }

  .total-price {
    font-size: 16px;
    color: #f56c6c;
    font-weight: bold;
  }
}

.el-descriptions {
  margin-bottom: 20px;
}
/* 添加自定义样式 */
.container-input {
  width: 300px;
  float: right;
  margin-top: -5px;
}

.el-icon-box {
  font-size: 16px;
  color: #409EFF;
}

.status-tag {
  margin-bottom: 10rpx;
}
.status-unaccept { color: #FF4444; }
.status-accepted { color: #00BAAD; }
.status-cancel { color: #999; }

/* 按钮样式 */
.action-buttons button {
  margin: 10rpx;
  padding: 8rpx 20rpx;
  border-radius: 8rpx;
  font-size: 28rpx;
}

.port-select-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.port-select-box {
  flex: 1;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.barcode-image-container {
  text-align: center;
  padding: 15px;
}

/* 条形码图片样式 */
.barcode-image {
  width: 300px;
  height: auto;
  border: 1px solid #eee;
  margin: 0 auto;
}

/* 无条形码提示 */
.no-barcode {
  color: #909399;
  font-size: 14px;
  padding: 20px;
  text-align: center;
}

.port-select-box:hover {
  border-color: #c0c4cc;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.port-select-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
}

.port-select-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.port-info {
  flex: 1;
}

.port-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 4px;
}

.port-details {
  display: flex;
  gap: 10px;
  font-size: 12px;
  color: #909399;
}

.port-placeholder {
  flex: 1;
  color: #c0c4cc;
  font-size: 14px;
}

.select-icon {
  color: #c0c4cc;
}

/* 对话框样式 */
.port-dialog-content {
  padding: 10px;
}

.port-search-box {
  margin-bottom: 20px;
}

.port-list {
  max-height: 400px;
  overflow-y: auto;
}

.port-item {
  padding: 12px;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
  transition: background-color 0.3s;
}

.port-item:hover {
  background-color: #f5f7fa;
}

.port-item.selected {
  background-color: #ecf5ff;
  border-left: 3px solid #409eff;
}

.port-item-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 6px;
}

.port-item-details {
  display: flex;
  gap: 15px;
  font-size: 13px;
  color: #909399;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .port-select-container {
    flex-direction: column;
    gap: 10px;
  }
}

.btn-accept { background: #00BAAD; color: white; }
.btn-cancel { background: #CCCCCC; color: #666; }
.btn-merchant { background: #4A90E2; color: white; }
.btn-goods { background: #FF8D1A; color: white; }
.btn-download { background: #7ED321; color: white; }

/* 移动端适配 */
@media (max-width: 768px) {
  .container-input {
    width: 100%;
    margin-top: 10px;
    float: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/shippingdetail.vue